export const GET_ALL_CONTACTUSS = "GET_ALL_CONTACTUSS";
export const GET_ALL_CONTACTUSS_SUCCESS = "GET_ALL_CONTACTUSS_SUCCESS";
export const GET_ALL_CONTACTUSS_FAILURE = "GET_ALL_CONTACTUSS_FAILURE";

export const EDIT_CONTACTUS = "EDIT_CONTACTUS";
export const EDIT_CONTACTUS_SUCCESS = "EDIT_CONTACTUS_SUCCESS";
export const EDIT_CONTACTUS_FAILURE = "EDIT_CONTACTUS_FAILURE";

export const GET_CONTACTUS = "GET_CONTACTUS";
export const GET_CONTACTUS_SUCCESS = "GET_CONTACTUS_SUCCESS";
export const GET_CONTACTUS_FAILURE = "GET_CONTACTUS_FAILURE";

export const DELETE_CONTACTUS = "DELETE_CONTACTUS";
export const DELETE_CONTACTUS_SUCCESS = "DELETE_CONTACTUS_SUCCESS";
export const DELETE_CONTACTUS_FAILURE = "DELETE_CONTACTUS_FAILURE";

export const ADD_CONTACTUS = "ADD_CONTACTUS";
export const ADD_CONTACTUS_SUCCESS = "ADD_CONTACTUS_SUCCESS";
export const ADD_CONTACTUS_FAILURE = "ADD_CONTACTUS_FAILURE";
